import React from 'react'
import {
  AccordionList,
  Button,
  Modal,
  Section,
  Table,
  Spinner,
} from '../../../components'
import {
  formatNumberWithCommaN2Decimal,
  formatNumberWithCommaN4Decimal,
  dateMonDayYearTimeFull,
} from '../../../helpers'
import { ROLE_BUYER } from '../../../store/role/constants'

const ModalHistoryOfSupplier = ({
  modals,
  itemBidHistory,
  eventData,
  itemBidClick,
  role,
  bidHistoryId,
  bidHistoryLength,
  handlersClose,
  loadingViewBid,
}) => {
  const title = (info, index, length) => {
    return (
      <div className="title-accordion-summary">
        <div className="no">
          <b>
            NO.{' '}
            {role === ROLE_BUYER
              ? length - index
              : bidHistoryLength - bidHistoryId}
          </b>{' '}
          {dateMonDayYearTimeFull(info.log_time)}
        </div>
        <div className="bidding-amount">
          {/* 2 decimal */}
          TOTAL BIDDING AMOUNT{' '}
          <b>
            {formatNumberWithCommaN2Decimal(info.total) +
              ' ' +
              eventData.currency}
          </b>
        </div>
      </div>
    )
  }

  const renderBodyContent = () => {
    return (
      <Section
        style={{ justifyContent: 'center' }}
        className="table-header-freeze-wrapper"
      >
        {loadingViewBid ? (
          <Spinner />
        ) : itemBidHistory && itemBidHistory.length > 0 ? (
          itemBidHistory.map((item, i) => {
            return (
              <AccordionList
                key={i}
                title={title(item, i, itemBidHistory.length)}
              >
                {renderItemList(item)}
              </AccordionList>
            )
          })
        ) : (
          'Data not found'
        )}
      </Section>
    )
  }

  const renderItemList = list => {
    return (
      <Section className="compare-event-table-wrapper">
        <Table className="history-log-data header-freeze">
          <Table.TBODY>
            <Table.TR className="modal-history-of-supplier">
              <Table.TH className="no">No.</Table.TH>
              <Table.TH className="item-name">ITEM NAME</Table.TH>
              <Table.TH className="description">DESCRIPTION</Table.TH>
              <Table.TH className="quantity">QUANTITY</Table.TH>
              <Table.TH className="uom">UOM</Table.TH>
              <Table.TH className="unit-price">
                UNIT PRICE({eventData.currency})
              </Table.TH>
              <Table.TH className="total-price">
                TOTAL PRICE({eventData.currency})
              </Table.TH>
            </Table.TR>
          </Table.TBODY>
          <Table className="history-log-data split-row-color css-table-his">
            <Table.TBODY>{renderItem(list.items)}</Table.TBODY>
          </Table>
        </Table>
      </Section>
    )
  }

  const renderItem = list => {
    if (list && list.length > 0) {
      return list.map((item, i) => {
        return (
          <Table.TR key={i} className="modal-history-of-supplier">
            <Table.TD className="no">{i + 1}</Table.TD>
            <Table.TD className="item-name">{item.name}</Table.TD>
            <Table.TD className="description">{item.description}</Table.TD>
            <Table.TD className="quantity">
              {/* 2 decimal */}
              {formatNumberWithCommaN2Decimal(item.qty)}
            </Table.TD>
            <Table.TD className="uom">{item.uom}</Table.TD>
            <Table.TD className="unit-price">
              {/* 4 decimal */}
              {formatNumberWithCommaN4Decimal(item.unit_price)}
            </Table.TD>
            <Table.TD className="total-price">
              {/* 2 decimal */}
              {formatNumberWithCommaN2Decimal(item.total_price)}
            </Table.TD>
          </Table.TR>
        )
      })
    }
  }

  return (
    <Modal
      className="theme-blue modals-history-of-supplier"
      isOpen={
        modals
          .filter(modal => {
            return modal.name === 'modals-history-of-supplier'
          })
          .map(obj => obj.isOpen)[0]
      }
    >
      <Modal.Header>
        HISTORY Of SUPPLIER
        {role === ROLE_BUYER &&
          ` : ${itemBidClick && itemBidClick.company_name}`}
      </Modal.Header>
      <Modal.Body>{renderBodyContent()}</Modal.Body>
      <Modal.Footer>
        <Button className="theme-green close" onClick={handlersClose}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalHistoryOfSupplier
